import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import type { CandidateShareUserGroup } from '@core/sharing-container-types';
import { AccessKind } from '@core/sharing-container-types';
import { BoxComponent } from '@core/user-interface-legacy';

import { UsersGroupedByAccessKindListItemComponent } from './users-grouped-by-access-kind-list-item/users-grouped-by-access-kind-list-item.component';

@Component({
  selector: 'rt-users-grouped-by-access-kind-list',
  imports: [BoxComponent, UsersGroupedByAccessKindListItemComponent],
  templateUrl: './users-grouped-by-access-kind-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './users-grouped-by-access-kind-list.component.less',
})
export class UsersGroupedByAccessKindListComponent {
  public readonly AccessKind = AccessKind;

  public usersGroupedByAccessKind = input.required<CandidateShareUserGroup[]>();
}
